import type { ReploMixedStyleValue } from "replo-runtime/store/utils/mixed-values";

import * as React from "react";

import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import LineHeight from "@replo/design-system/icons/static/line-height";
import { LengthInputSelector } from "@v1/components/editor/page/element-editor/components/modifiers/LengthInputModifier";
import { styleAttributeToEditorData } from "@v1/utils/styleAttribute";
import { CSS_LENGTH_TYPES_WITH_COMPUTED } from "replo-runtime/shared/utils/units";

import ModifierLabel from "../../extras/ModifierLabel";

interface LineHeightSelectorProps {
  lineHeight: string | ReploMixedStyleValue | null;
  onChange: (value: string) => void;
}

const LineHeightSelector: React.FC<LineHeightSelectorProps> = ({
  lineHeight,
  onChange,
}) => {
  const lineHeightDefaultValue =
    styleAttributeToEditorData.lineHeight.defaultValue;

  return (
    <LengthInputSelector
      label={<ModifierLabel label="Line" />}
      startEnhancer={
        <Tooltip content="Line Height" triggerAsChild>
          <span tabIndex={0}>
            <LineHeight size={12} />
          </span>
        </Tooltip>
      }
      metrics={CSS_LENGTH_TYPES_WITH_COMPUTED}
      field="style.lineHeight"
      value={lineHeight}
      anchorValue={lineHeightDefaultValue}
      dragTrigger="label"
      minDragValues={{ px: 0 }}
      minValues={{ px: 0 }}
      resetValue={lineHeightDefaultValue}
      allowsNegativeValue={false}
      previewProperty="lineHeight"
      onChange={onChange}
    />
  );
};

export default LineHeightSelector;
